import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["key", "isQa", "hublet"];
import reportErrorToLogFetch from './reportErrorToLogFetch';
import reportErrorToGrafana from './reportErrorToGrafana';
import { RENDER_SUCCESS, FALLBACK_DEFINITION_SUCCESS, DEFINITION_SUCCESS, SUBMISSION_SUCCESS, SUBMISSION_FAILURE, RECAPTCHA_VALIDATION_ERROR, SUBMIT_ATTEMPT_WITH_VALIDATION_ERRORS, SUBMIT_ATTEMPT_WITH_SUBMISSION_VALIDATION_ERRORS } from 'ui-forms-embed-components-reporting/reporting/internal/constants';
const isGrafanaOnlyEvent = eventKey => [RENDER_SUCCESS, DEFINITION_SUCCESS, FALLBACK_DEFINITION_SUCCESS, SUBMISSION_SUCCESS, SUBMISSION_FAILURE, RECAPTCHA_VALIDATION_ERROR, SUBMIT_ATTEMPT_WITH_VALIDATION_ERRORS, SUBMIT_ATTEMPT_WITH_SUBMISSION_VALIDATION_ERRORS].includes(eventKey);
const reportEvent = _ref => {
  let {
      key,
      isQa = false,
      hublet = ''
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!isGrafanaOnlyEvent(key)) {
    reportErrorToLogFetch(Object.assign({
      key,
      isQa,
      hublet
    }, rest));
  }
  reportErrorToGrafana({
    key,
    isQa,
    hublet
  });
};
export default reportEvent;